import { gql, useApolloClient, useMutation, useQuery } from "@apollo/client";
import {
  WBAlert,
  WBFlex,
  WBLink,
  WBLinkButton,
  WBTypography,
} from "@apptractive/design-system-web";
import { CSGetSub as GET_SUB } from "../../customGraphql/queries";
import { getUser } from "../../graphql/queries";
import {
  PRIVACY_POLICY_URL,
  PRIVACY_POLICY_URL_CH,
  TERMS_CONDITIONS_URL,
  TERMS_CONDITIONS_URL_CH,
} from "@apptractive/stm-shared";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ChangeLanguage } from "../../components/ChangeLanguage";
import { Link } from "../../components/Link";
import { PageContainer } from "../../components/PageContainer";
import { CSDeleteAccount as DELETE_ACCOUNT } from "../../customGraphql/mutations";
import { PATHS } from "../../navigation/paths";

const Settings = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const client = useApolloClient();
  const { data: subData } = useQuery(gql(GET_SUB));
  const { data: userData } = useQuery(gql(getUser), {
    variables: {
      id: subData?.sub,
    },
  });
  const user = useMemo(() => userData?.getUser || {}, [userData]);
  const [deleteAccount, { error: deleteError }] = useMutation(
    gql(DELETE_ACCOUNT)
  );

  const onDeleteAccount = async () => {
    const confirm = window.confirm(t("confirmDeleteAccount", { ns: "common" }));

    if (confirm) {
      try {
        await deleteAccount();
        client.cache.gc();
        navigate(PATHS.signIn, { replace: true });
      } catch (err) {}
    }
  };

  return (
    <PageContainer sx={{ alignItems: "flex-start" }}>
      <WBTypography variant="h1">
        {t("settingsTitle", { ns: "common" })}
      </WBTypography>
      <WBTypography variant="h4">
        {t("accountTitle", { ns: "common" })}
      </WBTypography>
      <Link to={PATHS.changePassword}>
        {t("changePasswordTitle", { ns: "common" })}
      </Link>
      <WBLinkButton sx={{ mt: 1 }} onClick={onDeleteAccount} color="red">
        {t("deleteAccountTitle", { ns: "common" })}
      </WBLinkButton>
      <WBFlex flexDirection="row" alignItems="center">
        <WBTypography>{t("languageTitle", { ns: "common" })}</WBTypography>
        <ChangeLanguage />
      </WBFlex>
      <WBTypography variant="h4" mt={3}>
        {t("legalTitle", { ns: "common" })}
      </WBTypography>
      <WBLink
        href={
          user?.country === "CH" ? PRIVACY_POLICY_URL_CH : PRIVACY_POLICY_URL
        }
        target="_blank"
      >
        {t("privacyPolicyTitle", { ns: "common" })}
      </WBLink>
      <WBLink
        href={
          user?.country === "CH"
            ? TERMS_CONDITIONS_URL_CH
            : TERMS_CONDITIONS_URL
        }
        target="_blank"
      >
        {t("termsConditionsTitle", { ns: "common" })}
      </WBLink>
      {deleteError?.message && (
        <WBAlert title={deleteError?.message} severity="error" sx={{ my: 2 }} />
      )}
    </PageContainer>
  );
};

export default Settings;
